import './Navbar.css';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight, faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import schoolBadge from './Component/Photoset/schoolBadge.svg';
import { Link, resolvePath, useMatch, useResolvedPath, useLocation } from 'react-router-dom';

function Navbar() {

    const [menuOpen, setMenuOpen] = useState(false);
    let barsIcon;
    if (menuOpen) {
        barsIcon = <FontAwesomeIcon icon={faXmark} />
    } else {
        barsIcon = <FontAwesomeIcon icon={faBars} />
    }

    return (
        <>
            <ul className='navbar'>
                <div className='school'>
                    <Link to='/'><img src={schoolBadge} alt="schoolBadge"></img></Link>
                    <div className='school-text'>
                        <h id='school-name'>โรงเรียนเทศบาลตำบลพยัคฆภูมิพิสัย</h>
                        <br></br>
                        <h id='school-name-eng'>PHAYAKKHAPHUM PHISAI SUB DISTRICT MUNICIPALITY SCHOOL</h>
                        <br></br>
                        <h id='district'>สำนักงานเขตพื้นที่การศึกษาสังกัดเทศบาลตำบลพยัคฆภูมิพิสัย</h>
                    </div>
                </div>

                <div className='bars-menu' onClick={() => {
                    setMenuOpen(!menuOpen)
                }}>
                    {barsIcon}
                </div>
                <div>
                    <ul className={`choices ${menuOpen ? "open" : "hide"}`}>
                        <li><CustomLink to='/'>หน้าหลัก</CustomLink></li>
                        <li><MainChoice id='information'>ข้อมูลทั่วไป<div><FontAwesomeIcon icon={faChevronDown} /></div></MainChoice>
                            <ul className='dropdown info'>
                                <li><CustomLink to='/information/history'>- ประวัติโรงเรียน</CustomLink></li>
                                <li><CustomLink to='/information/administrator'>- ผู้บริหาร</CustomLink></li>
                            </ul>
                        </li>
                        <li><MainChoice id='subject' >กลุ่มสาระการเรียนรู้<div><FontAwesomeIcon icon={faChevronDown} /></div></MainChoice>
                            <ul className='dropdown subject'>
                                <li><CustomLink to='/subject/social'>- สังคมศึกษาฯ</CustomLink></li>
                                <li><CustomLink to='/subject/english'>- ภาษาต่างประเทศ</CustomLink></li>
                                <li><CustomLink to='/subject/health'>- สุขศึกษาและพลศึกษา</CustomLink></li>
                                <li><CustomLink to='/subject/career'>- การงานอาชีพ</CustomLink></li>
                                <li><CustomLink to='/subject/art'>- ศิลปะฯ</CustomLink></li>
                                <li><CustomLink to='/subject/science'>- วิทยาศาสตร์</CustomLink></li>
                                <li><CustomLink to='/subject/thai'>- ภาษาไทย</CustomLink></li>
                                <li><CustomLink to='/subject/math'>- คณิตศาสตร์</CustomLink></li>
                            </ul>
                        </li>
                        <li><Link id='more'>เพิ่มเติม<div><FontAwesomeIcon icon={faChevronDown} /></div></Link>
                            <ul className='dropdown more-info'>
                                <li><Link to='https://drive.google.com/drive/folders/1UnfEb1R2rXJD8B8UiNFMO8RzHoKmb09S' target='_blank'>- ปฏิทินการศึกษา</Link></li>
                                <li><Link to='' target='_blank'>- ตารางเรียน</Link></li>
                                <li><Link to='' target='_blank'>- ตารางสอน</Link></li>
                                <li><Link to='' target='_blank'>- รายชื่อนักเรียน</Link></li>
                            </ul>
                        </li>
                        <li><CustomLink to='/contact'>ติดต่อเรา</CustomLink></li>
                    </ul>
                </div>
            </ul>
        </>
    );
}
export default Navbar

function CustomLink({ to, children, ...props }) {
    const resolvePath = useResolvedPath(to)
    const isActive = useMatch({ path: resolvePath.pathname, end: true })
    return (
        <Link to={to} {...props} className={isActive ? "active" : ""}>{children}</Link>
    )
}

function MainChoice({ id, children }) {
    const location = useLocation();
    const path = location.pathname;
    const splitPath = path.split("/")[1];
    const isActive = splitPath === id;

    return (
        <Link className={isActive ? "active" : ""}>{children}</Link>
    );
}





